module.exports = __webpack_public_path__ + "img/ic-user-pay.cca6fc46.svg";